import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    // height: 500,
    width: 600,
  },
}));
